import React from "react";
// 1. Importar Link para a navegação do React Router
import { Link } from "react-router-dom";
// 2. Importar newsArticles do arquivo de dados (assumindo o caminho)
import { newsArticles } from "../data/newsData";
// NOTA: As importações individuais de imagens foram removidas, pois já estão nos objetos de newsArticles.

const BlogArticles = () => {
  return (
    <section className="w-full px-6 py-10 overflow-hidden relative bg-[#fbf7f7]">
       <p className="text-lg sm:text-xl md:text-2xl font-bold text-[#004452] ms-4 mb-2">
              Blog
            </p>
      <div className="flex gap-6 animate-slide">
        {newsArticles.concat(newsArticles).map((article, index) => (
          // O LINK agora envolve o card inteiro para ser clicável
          <Link
            // A rota aponta para o ID do artigo, conforme configurado no App.js
            to={`blog/artigos/${article.id}`}
            key={index}
            // Classes do seu layout original aplicadas no Link
            className="flex-shrink-0 w-[470px] sm:w-[670px] h-[190px] p-2 bg-gradient-to-r from-[#FFFFFF] to-[#fbf7f7] rounded shadow-sm overflow-hidden flex flex-row hover:shadow-lg transition-shadow duration-300"
          >
            {/* Imagem */}
            <div className="w-1/3 h-auto">
              <img
                src={article.image}
                alt={article.title}
                className="w-full h-full object-cover rounded"
              />
            </div>

            {/* Conteúdo */}
            <div className="flex-1 p-4 flex flex-col justify-between">
              {/* O cabeçalho foi ajustado para DIVs, já que está dentro de um Link */}
              <div className="flex flex-row items-center justify-between">
                <h3 className="font-bold text-black text-sm leading-snug pr-2">
                  {article.title}
                </h3>
                {/* O antigo botão agora é um DIV visual que se comporta como um link */}
                <div className="bg-black text-white px-2 py-1.5 rounded-full shadow-md transition-colors duration-300 flex items-center gap-2 w-fit whitespace-nowrap">
                  <span className="pl-2 font-medium text-sm">Confira</span>
                  <div className="flex items-center justify-center w-7 h-7 rounded-full bg-white text-black">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="h-4 w-4 transform -rotate-45"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                      strokeWidth={2}
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M14 5l7 7m0 0l-7 7m7-7H3"
                      />
                    </svg>
                  </div>
                </div>
              </div>
              <p className="text-xs text-gray-500 mt-1">
                {article.date} • {article.type}
              </p>

              <p className="text-sm text-gray-500 mt-2 line-clamp-3">
                {article.description}
              </p>

            </div>
          </Link>
        ))}
      </div>
    </section>
  );
};

export default BlogArticles;